<template>

  <div v-if="tasks">
    <TaskList
      @hideModal="hide()" 
      @deleted="hide()" />
  </div>
  
</template>

<script>
import TaskList from './TaskList'

export default {
  name: 'TaskObserver',
  components: {
    TaskList
  },
  data () {
    return {
    }
  },
  computed: {
    tasks () {
      return this.$route.query.tasks
    }
  },
  created () {
  },
  methods: {
    hide () {
      this.$changeUrlParam({
        tasks: undefined
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Task/TaskObserver.vue